export const NEWSLETTER_REQUEST_START = 'BEAMLY/CCX/NEWSLETTER_REQUEST_START';
export const NEWSLETTER_REQUEST_PENDING = 'BEAMLY/CCX/NEWSLETTER_REQUEST_PENDING';
export const NEWSLETTER_REQUEST_FAIL = 'BEAMLY/CCX/NEWSLETTER_REQUEST_FAIL';
export const NEWSLETTER_REQUEST_SUCCESS = 'BEAMLY/CCX/NEWSLETTER_REQUEST_SUCCESS';
export const RESET_NEWSLETTER = 'BEAMLY/CCX/RESET_NEWSLETTER';
export const NEWSLETTER_SET_INPUT_VALUE = 'BEAMLY/CCX/NEWSLETTER_SET_INPUT_VALUE';
export const NEWSLETTER_RESET_INPUT_VALUE = 'BEAMLY/CCX/NEWSLETTER_RESET_INPUT_VALUE';
